import { render, staticRenderFns } from "./AbsentLetterTable.vue?vue&type=template&id=24bf9828&scoped=true"
import script from "./AbsentLetterTable.vue?vue&type=script&lang=js"
export * from "./AbsentLetterTable.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterTable.vue?vue&type=style&index=0&id=24bf9828&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf9828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bf9828')) {
      api.createRecord('24bf9828', component.options)
    } else {
      api.reload('24bf9828', component.options)
    }
    module.hot.accept("./AbsentLetterTable.vue?vue&type=template&id=24bf9828&scoped=true", function () {
      api.rerender('24bf9828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/AbsentLetterTable.vue"
export default component.exports